import { Input, InputProps } from '@chakra-ui/react'
import { useEffect } from 'react'
import { Controller, FieldValues, Path } from 'react-hook-form'

import { InputMasks } from '@/utils/helpers/TextMasks'

import { Inputs } from './models'

interface MyProps<T extends FieldValues, K extends Path<T>>
  extends Inputs.InputData<T, K>,
    InputProps {
  inputMask: keyof typeof InputMasks
}

export default function <T extends FieldValues, K extends Path<T>>(
  props: MyProps<T, K>,
) {
  const {
    useForm: { control },
    useFormField,
    inputMask,
    ...rest
  } = props

  return (
    <Controller
      control={control}
      name={useFormField}
      render={({ field: { onChange, value } }) => {
        useEffect(() => {
          const maskedValue = InputMasks[inputMask](value)
          onChange(maskedValue)
        }, [inputMask])

        return (
          <Input
            onChange={(e) => {
              const maskedValue = InputMasks[inputMask](e.target.value)
              onChange(maskedValue)
            }}
            value={value}
            {...rest}
          />
        )
      }}
    />
  )
}
